
























import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import vouchersModel from "../models/voucher.model";

@Component({
  components: { EntityCrud },
})
export default class Vouchers extends Vue {
  model: any = vouchersModel;
  voucherAmount: number = 1;
  activePrompt: boolean = false;
  dialogTitle: string = "Quantidade de vouchers";
  customCreate: any = this.createVouchers;
  customCreateTitle: string = "Gerar Vouchers";

  title = "Vouchers Empresariais";
  tableColumns = ["id", "createdDate", "code", "totalAppointments", "usedAppointments", "company"];

  formColumns = ["id", "code", "totalAppointments", "usedAppointments", "company"];
  defaultEntity = { totalAppointments: 5, usedAppointments: 0 };

  actions = [{ kind: 'FORM', name: 'Criar Vouchers ', color: 'primary', action: this.createVouchers }]
  selectedVoucher: any;
  
  validAmount(): boolean {
    //console.log('valid amount', this.voucherAmount)
    return this.voucherAmount > 0;
  }


  async acceptAlert() {
    //console.log('amount', this.voucherAmount)
    this.$vs.loading();
    try {      
      //criar os vauchers
      this.selectedVoucher.vouchersAmount = this.voucherAmount;
      await this.model.create(this.selectedVoucher);
      this.voucherAmount = 1;
      this.$vs.notify({ title: "Sucesso", text: "Os dados foram enviados.", iconPack: "feather", icon: "icon-check", color: "success" });
      this.$router.back()
    } catch (error) {
      console.error(error);
      this.$vs.notify({ title: "Erro", text: error.friendlyMessage || "Ocorreu um erro. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
    }
    this.$vs.loading.close();
  }

  async createVouchers(data: any) {
    //console.log(data);
    this.selectedVoucher = data;
    this.activePrompt = true;
  }
}
